import { MapContainer, TileLayer, Polyline, Marker, Popup, CircleMarker } from "react-leaflet";
import L from "leaflet";

const START_ICON = L.divIcon({
    className: "",
    html: '<div class="cp-balade-marker cp-balade-marker--start">Départ</div>',
    iconSize: [60, 26], iconAnchor: [30, 13],
});
const END_ICON = L.divIcon({
    className: "",
    html: '<div class="cp-balade-marker cp-balade-marker--end">Arrivée</div>',
    iconSize: [60, 26], iconAnchor: [30, 13],
});

// Compute bounds from a list of [lat, lng] pairs
function boundsOf(points) {
    if (!points?.length) return null;
    const lats = points.map((p) => p[0]);
    const lngs = points.map((p) => p[1]);
    return [
        [Math.min(...lats), Math.min(...lngs)],
        [Math.max(...lats), Math.max(...lngs)],
    ];
}

export default function BaladeMap({ waypoints, startLat, startLng, title }) {
    const points = waypoints && waypoints.length >= 2
        ? waypoints
        : (startLat && startLng ? [[startLat, startLng]] : []);

    if (!points.length) return null;

    const bounds = boundsOf(points);
    const start = points[0];
    const end = points[points.length - 1];
    const hasRoute = points.length >= 2;

    return (
        <div
            data-testid="balade-map"
            className="aspect-[16/10] md:aspect-[16/8] w-full overflow-hidden border border-cp-border bg-cp-craie"
        >
            <MapContainer
                bounds={bounds}
                boundsOptions={{ padding: [28, 28] }}
                scrollWheelZoom={false}
                className="h-full w-full"
                attributionControl={false}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                    attribution='&copy; OpenStreetMap · Côte Perdue'
                />

                {hasRoute && (
                    <>
                        {/* Shadow for depth */}
                        <Polyline
                            positions={points}
                            pathOptions={{ color: "#000", weight: 7, opacity: 0.18 }}
                        />
                        {/* Main route */}
                        <Polyline
                            positions={points}
                            pathOptions={{
                                color: "#2d4a3c",
                                weight: 4,
                                opacity: 0.95,
                                dashArray: "1 8",
                                lineCap: "round",
                            }}
                        />
                        {/* Waypoint dots */}
                        {points.slice(1, -1).map((p, i) => (
                            <CircleMarker
                                key={i}
                                center={p}
                                radius={5}
                                pathOptions={{ color: "#fff", fillColor: "#2d4a3c", fillOpacity: 1, weight: 2 }}
                            />
                        ))}
                    </>
                )}

                <Marker position={start} icon={START_ICON}>
                    <Popup>
                        <div className="cp-serif italic text-cp-foret">Départ</div>
                        <div className="cp-tiny text-cp-gris">{title}</div>
                    </Popup>
                </Marker>

                {hasRoute && (
                    <Marker position={end} icon={END_ICON}>
                        <Popup>
                            <div className="cp-serif italic text-cp-foret">Arrivée</div>
                            <div className="cp-tiny text-cp-gris">{title}</div>
                        </Popup>
                    </Marker>
                )}
            </MapContainer>
        </div>
    );
}
